module.exports = __webpack_public_path__ + "img/student2.552d2e63.png";